import { render, staticRenderFns } from "./wxBindingComponent.vue?vue&type=template&id=cc8fd472"
import script from "./wxBindingComponent.vue?vue&type=script&lang=js"
export * from "./wxBindingComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports